// extracted by mini-css-extract-plugin
module.exports = {"filters":"TaskLogs_filters__3n4-X"};